/*
 * Module for the survey tab on the Topic page
 */

define([
  "marionette",
  "moment",
  "messaging/messenger",
  "modules/topicsSplit/topic/topicSurvey/topicSurveyView",
  "modules/reportSplit/reports/singleReport/singleReportModule",
], function (Marionette, Moment, Messenger, TopicSurveyView, SingleReportModule) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "topicSurvey";
      this.region = options.region;
    },
    show: function (topic) {
      this.reports = Messenger.reqres.request("reports");
      this.layout = new TopicSurveyView.topicSurveyLayout();
      this.surveyChart = this.addSubModule(
        new SingleReportModule({ region: this.layout.surveyChart }),
      );
      this.layout.on(
        "show",
        function () {
          this._showSubViews(topic);
        },
        this,
      );

      Messenger.reqres.setHandler(
        "report:layout",
        function () {
          return this.layout;
        },
        this,
      );

      this.showRegion(this.layout);
    },
    _showSubViews: function (topic) {
      Messenger.reqres.setHandler(
        "param:{touchpoint}",
        function () {
          const tps = Messenger.reqres.request("kb:touchpoints");
          let touchPointIdList = "";
          tps.each(function (tp) {
            touchPointIdList += tp.get("touchPointId") + "_";
          });
          return touchPointIdList;
        },
        this,
      );
      Messenger.reqres.setHandler(
        "param:{topic}",
        function () {
          return topic.get("intentId");
        },
        this,
      );
      Messenger.reqres.setHandler(
        "paramDisplay:{topic}",
        function () {
          return topic.get("intentName");
        },
        this,
      );
      Messenger.reqres.setHandler(
        "param:{startDate}",
        function () {
          this.DAYS_BACK = 365;
          return Moment().subtract("days", this.DAYS_BACK).valueOf(); //start date is X days ago
        },
        this,
      );
      Messenger.reqres.setHandler(
        "param:{endDate}",
        function () {
          return Moment().valueOf(); //get current date
        },
        this,
      );
      Messenger.reqres.setHandler("param:{language}", function () {
        return Messenger.reqres.request("default:response:language");
      });
      Messenger.reqres.setHandler("param:{analyticsTags}", () => "");
      this.reports.on(
        "sync",
        function () {
          const surveyReport = this.surveyChart.findReport(
            this.reports,
            "reports.topicSurvey.name",
          );
          this.surveyChart.showIndividualReport(surveyReport);
        },
        this,
      );
    },
  });
});
